import Vue from 'vue'
import Vuex from 'vuex'
import base from './base';
import twilio from './twilio';
import guide from './guide';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    base,
    twilio,
    guide
  }
})
